import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AnomalyDetection, AnomalyDetectionCreate, AnomalyDetectionFilter } from '../data/anomalyDetection';

export function createAnomalyDetectionService(client: AxiosInstance) {
  return createCrudService<AnomalyDetection, AnomalyDetectionCreate, AnomalyDetectionFilter>(
    client,
    '/ai/AnomalyDetection',
    'id',
  );
}

export type AnomalyDetectionService = CrudService<AnomalyDetection, AnomalyDetectionCreate, AnomalyDetectionFilter>;
